<div class="flex bg-slate-200" (window:keydown.enter)="confirm()">

  <!-- Content -->
  <div class="h-screen flex-[7] flex flex-col justify-center">
    <div class="flex justify-center mr-[22rem] py-10">
      <button (click)="goBack()">
        <img src="assets/images/left_arrow.png" alt="back" [width]="25">
      </button>
    </div>

    <h1 class="text-4xl  text-center font-semibold md:ml-[7rem]">Confirmar Pagamento</h1>

    <!-- Dados -->
    <div class="md:ml-[8rem]">
      <div class="space-y-4 p-6 max-w-md mx-auto">
        

        <!-- Product -->
        <div class="bg-white rounded-xl p-4">
          <span class="text-gray-500">Nome do Produto</span>
          <p class="text-black font-medium mt-2">{{linkInfo.title}}</p>
        </div>

        <!-- Note -->
        <div class="bg-white rounded-xl p-4">
          <span class="text-gray-500">Nota</span>
          <p class="text-black font-medium mt-2">{{linkInfo.short_description}}</p>
        </div>

        <!-- Payee Information -->
        <div class="bg-white rounded-xl p-4">
          <div class="flex justify-between">
            <span class="text-gray-500">Pagar para</span>
            <span class="text-black font-medium">{{linkInfo.store_name}}</span>
          </div>
          <div class="flex justify-between mt-2">
            <span class="text-gray-500">Pagar com</span>
            <span class="text-black font-medium">{{linkServ.getPaymentNumber()}}</span>
          </div>
        </div>

        <!-- Payment Details -->
        <div class="bg-white rounded-xl p-4 space-y-2">
          <div class="flex justify-between">
            <span class="text-gray-500">Montante</span>
            <span class="text-black font-medium">{{ linkInfo.amount| currency: '': '':'1.2-2' }} MZN</span>
          </div>
        </div>

        
      </div>
    </div>

    <div class="flex justify-center md:ml-[10rem] py-20">
      <div class="w-[50vw] md:w-[25vw]">
        <button 
          (click)="confirm()"
          class="w-full py-2 rounded-full bg-customGreen text-xl text-white">
          Continuar
        </button>
      </div>
    </div>
  </div>

  <!-- Right Panel -->
  <div class="flex-[3] hidden lg:block">
    <div class="flex flex-col justify-around items-center h-screen rounded-s-[2rem] bg-white drop-shadow-md">
      <div>
        <img src="assets/images/imali_logo.png" alt="imali_logo" class="w-20">
        <p class="py-10">Aproveita o teu dinheiro da melhor forma.</p>
        <a href="https://imali.co.mz/" target="_blank" class="underline">Saber Mais</a>
      </div>
    </div>
  </div>
</div>